import { Routes } from './routes';

declare let window: { routes: Routes };

/**
 * Load the routes on the window object
 *
 * This is used to debug the routes in the browser console
 */
export const loadRoutesInWindow = (routes: Routes): void => {
  window.routes = routes;
};
